module.exports = __webpack_public_path__ + "img/excellentG.6f13c8c7.png";